export default function DSA_0_1_Knapsack() {
  return <div>DSA_0_1_Knapsack Component</div>;
}
